import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "80%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Scheduled commissions modifications")])]), _c(VCardText, [_c(VExpansionPanels, {
    attrs: {
      multiple: ""
    },
    model: {
      value: _vm.openedPanels,
      callback: function callback($$v) {
        _vm.openedPanels = $$v;
      },
      expression: "openedPanels"
    }
  }, [_c(VExpansionPanel, {
    staticClass: "rounded",
    attrs: {
      "active-class": "rounded"
    }
  }, [_c(VExpansionPanelHeader, [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v("Schedule a new modification")])]), _c(VExpansionPanelContent, [_c("div", {
    staticClass: "add-content"
  }, [_c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Future commission (%)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      type: "number",
      rules: [_vm.rules.mustNotBeEmpty],
      required: ""
    },
    model: {
      value: _vm.form.futurePercentageFee,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "futurePercentageFee", $$v);
      },
      expression: "form.futurePercentageFee"
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Application date")]), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "v-text-field-no-label",
          attrs: {
            type: "date",
            required: "",
            rules: [_vm.rules.mustNotBeEmpty]
          },
          model: {
            value: _vm.form.scheduledApplicationDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "scheduledApplicationDate", $$v);
            },
            expression: "form.scheduledApplicationDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.addDateMenu,
      callback: function callback($$v) {
        _vm.addDateMenu = $$v;
      },
      expression: "addDateMenu"
    }
  }, [_c(VDatePicker, {
    attrs: {
      min: _vm.minDate
    },
    on: {
      input: function input($event) {
        _vm.addDateMenu = false;
      }
    },
    model: {
      value: _vm.form.scheduledApplicationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "scheduledApplicationDate", $$v);
      },
      expression: "form.scheduledApplicationDate"
    }
  })], 1)], 1)]), _c("div", {
    staticClass: "filters-inline"
  }, [_c("div", [_c("div", [_vm._v("User group")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label v-min-height-select-chips",
    attrs: {
      items: _vm.listUserGroup,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "value",
      label: !_vm.form.userGroup ? "All" : "",
      clearable: "",
      disabled: !!_vm.form.userId || !!_vm.form.consultantId
    },
    model: {
      value: _vm.form.userGroup,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "userGroup", $$v);
      },
      expression: "form.userGroup"
    }
  })], 1), _c("div", [_vm._v("Or")]), _c("div", [_c("div", [_vm._v("User")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label v-min-height-select-chips",
    attrs: {
      items: _vm.listUsers,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "full_name",
      label: !_vm.form.userId ? "All" : "",
      clearable: "",
      disabled: !!_vm.form.userGroup || !!_vm.form.consultantId
    },
    model: {
      value: _vm.form.userId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "userId", $$v);
      },
      expression: "form.userId"
    }
  })], 1), _c("div", [_vm._v("Or")]), _c("div", [_c("div", [_vm._v("Consultant / Corporate")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label v-min-height-select-chips",
    attrs: {
      items: _vm.listConsultants,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "full_name",
      label: !_vm.form.consultantId ? "All" : "",
      clearable: "",
      disabled: !!_vm.form.userGroup || !!_vm.form.userId
    },
    model: {
      value: _vm.form.consultantId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "consultantId", $$v);
      },
      expression: "form.consultantId"
    }
  })], 1)]), _c("div", [_c("div", [_vm._v("Countries")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listCountries,
      label: _vm.listCountries.length < 1 ? "Loading..." : _vm.form.countryIds.length > 0 ? "" : "All",
      color: "white",
      "item-value": "id_country",
      "item-text": "printable_name",
      placeholder: "Country name",
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.form.countryIds,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "countryIds", $$v);
      },
      expression: "form.countryIds"
    }
  })], 1), _c("div", {
    staticClass: "filters-inline"
  }, [_c("div", [_c("div", [_vm._v("Producers")]), _c(VAutocomplete, {
    staticClass: "py-0",
    attrs: {
      disabled: _vm.form.wineIds.length > 0,
      items: _vm.listWineries,
      color: "white",
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      label: _vm.listWineries.length < 1 ? "Loading..." : _vm.form.wineryIds.length > 0 ? "" : "All",
      placeholder: "Type a producer",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.wineryIds,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "wineryIds", $$v);
      },
      expression: "form.wineryIds"
    }
  })], 1), _c("div", [_vm._v("Or")]), _c("div", [_c("div", [_vm._v("Products")]), _c(VAutocomplete, {
    staticClass: "py-0",
    attrs: {
      disabled: _vm.form.wineryIds.length > 0,
      items: _vm.listWines,
      color: "white",
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "display_name",
      "item-value": "id_wine",
      label: _vm.listWines.length < 1 ? "Loading..." : _vm.form.wineIds.length > 0 ? "" : "All",
      placeholder: "Type a name, vintage or producer",
      clearable: "",
      multiple: "",
      chips: "",
      filter: _vm.filterVAutocomplete,
      "deletable-chips": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.wineIds,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "wineIds", $$v);
      },
      expression: "form.wineIds"
    }
  })], 1)]), _c("div", {
    staticClass: "flex justify-end mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isInvalidForm,
      loading: _vm.isAdding
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_c("i", {
    staticClass: "far fa-calendar-alt mr-1"
  }), _vm._v(" Schedule ")])], 1)])], 1), _vm.futureScheduledModifications.length > 0 ? _c(VExpansionPanel, {
    staticClass: "rounded",
    attrs: {
      "active-class": "rounded"
    }
  }, [_c(VExpansionPanelHeader, [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v(" " + _vm._s("Scheduled modifications (".concat(_vm.futureScheduledModifications.length, ")")) + " ")])]), _c(VExpansionPanelContent, [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.futureHeaders,
      items: _vm.futureScheduledModifications,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.scheduledApplicationDate",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.scheduledApplicationDate)) + " ")])];
      }
    }, {
      key: "item.userGroup",
      fn: function fn(_ref3) {
        var _item$consultant, _item$user;
        var item = _ref3.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.userGroup ? _vm.listUserGroup.find(function (x) {
          return x.id === item.userGroup;
        }).value : (_item$consultant = item.consultant) !== null && _item$consultant !== void 0 && _item$consultant.id ? item.consultant.name : (_item$user = item.user) !== null && _item$user !== void 0 && _item$user.id ? item.user.name : "All") + " ")])];
      }
    }, {
      key: "item.country",
      fn: function fn(_ref4) {
        var _item$country$name, _item$country;
        var item = _ref4.item;
        return [_c("div", [_vm._v(" " + _vm._s((_item$country$name = (_item$country = item.country) === null || _item$country === void 0 ? void 0 : _item$country.name) !== null && _item$country$name !== void 0 ? _item$country$name : "All") + " ")])];
      }
    }, {
      key: "item.winery",
      fn: function fn(_ref5) {
        var _item$winery$name, _item$winery;
        var item = _ref5.item;
        return [_c("div", [_vm._v(" " + _vm._s((_item$winery$name = (_item$winery = item.winery) === null || _item$winery === void 0 ? void 0 : _item$winery.name) !== null && _item$winery$name !== void 0 ? _item$winery$name : "All") + " ")])];
      }
    }, {
      key: "item.wine",
      fn: function fn(_ref6) {
        var _item$wine;
        var item = _ref6.item;
        return [_c("div", [_vm._v(" " + _vm._s((_item$wine = item.wine) !== null && _item$wine !== void 0 && _item$wine.id ? "".concat(item.wine.name, " ").concat(item.wine.sku) : "All") + " ")])];
      }
    }, {
      key: "item.action",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            title: "Cancel",
            rounded: "",
            disabled: item.isDeleting || _vm.isDeletingAll
          },
          on: {
            click: function click($event) {
              return _vm.confirmCancelScheduledModification(item);
            }
          }
        }, [_c("i", {
          staticClass: "fas fa-trash"
        })])], 1)];
      }
    }], null, true)
  }), _c("div", {
    staticClass: "mt-2 flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      title: "Cancel all",
      rounded: "",
      disabled: _vm.isDeletingAll || _vm.futureScheduledModifications.some(function (x) {
        return x.isDeleting;
      })
    },
    on: {
      click: function click($event) {
        return _vm.confirmCancelAllFutureModifications();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-trash"
  }), _vm._v(" CANCEL ALL ")])], 1)], 1)], 1) : _vm._e(), _vm.previousScheduledModifications.length > 0 ? _c(VExpansionPanel, {
    staticClass: "rounded",
    attrs: {
      "active-class": "rounded"
    }
  }, [_c(VExpansionPanelHeader, [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v(" " + _vm._s("History (".concat(_vm.previousScheduledModifications.length, ")")) + " ")])]), _c(VExpansionPanelContent, [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.previousHeaders,
      items: _vm.previousScheduledModifications,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actualApplicationDate",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.actualApplicationDate)) + " ")])];
      }
    }, {
      key: "item.userGroup",
      fn: function fn(_ref9) {
        var _item$consultant2, _item$user2;
        var item = _ref9.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.userGroup ? _vm.listUserGroup.find(function (x) {
          return x.id === item.userGroup;
        }).value : (_item$consultant2 = item.consultant) !== null && _item$consultant2 !== void 0 && _item$consultant2.id ? item.consultant.name : (_item$user2 = item.user) !== null && _item$user2 !== void 0 && _item$user2.id ? item.user.name : "All") + " ")])];
      }
    }, {
      key: "item.country",
      fn: function fn(_ref10) {
        var _item$country$name2, _item$country2;
        var item = _ref10.item;
        return [_c("div", [_vm._v(" " + _vm._s((_item$country$name2 = (_item$country2 = item.country) === null || _item$country2 === void 0 ? void 0 : _item$country2.name) !== null && _item$country$name2 !== void 0 ? _item$country$name2 : "All") + " ")])];
      }
    }, {
      key: "item.winery",
      fn: function fn(_ref11) {
        var _item$winery$name2, _item$winery2;
        var item = _ref11.item;
        return [_c("div", [_vm._v(" " + _vm._s((_item$winery$name2 = (_item$winery2 = item.winery) === null || _item$winery2 === void 0 ? void 0 : _item$winery2.name) !== null && _item$winery$name2 !== void 0 ? _item$winery$name2 : "All") + " ")])];
      }
    }, {
      key: "item.wine",
      fn: function fn(_ref12) {
        var _item$wine2;
        var item = _ref12.item;
        return [_c("div", [_vm._v(" " + _vm._s((_item$wine2 = item.wine) !== null && _item$wine2 !== void 0 && _item$wine2.id ? "".concat(item.wine.name, " ").concat(item.wine.sku) : "All") + " ")])];
      }
    }, {
      key: "item.futurePercentageFee",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.previousPercentageFee ? item.previousPercentageFee : "no") + " -> " + _vm._s(item.futurePercentageFee) + " ")])];
      }
    }], null, true)
  })], 1)], 1) : _vm._e()], 1)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };